// extracted by mini-css-extract-plugin
module.exports = {"container":"PdfViewer_container__1VGoE","pdfViewerModal":"PdfViewer_pdfViewerModal__2DU1F","page":"PdfViewer_page__3uBU2"};